export default {"src":"/_next/static/image/public/images/ExtraTwenty.adbbd252da419cd915070758ad99a741.svg","height":14,"width":14};